import { render, staticRenderFns } from "./tours.vue?vue&type=template&id=018858eb"
import script from "./tours.vue?vue&type=script&lang=js"
export * from "./tours.vue?vue&type=script&lang=js"
import style0 from "./tours.vue?vue&type=style&index=0&id=018858eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports